(function () {
    'use strict';
    var m = angular.module('app');
    m.directive('sideMenuHideToggle', ["sideMenuManager", function (sideMenuManager) {
        return {
            restrict: 'A',
            scope: {},
            link: function ($scope, element, attrs) {
                element.click(function () {
                    sideMenuManager.toggleHide();
                    $scope.$apply();
                });
            }
        };
    }]);
}());